<div
	[ngClass]="
		autoGenerated() || (isEmail() && !sentByMe())
			? 'incoming-comment-item'
			: 'outgoing-comment-item'
	"
>
	<div class="card-head">
		<au-round-avatar
			[fullName]="commentAuthorName"
			[smallAvatarUrl]="commentAuthorAvatar"
			[size]="40"
		/>
	</div>

	<div class="message-item">
		<div class="sent-from">
			@if (autoGenerated()) {
				{{ requester[0].name ? requester[0].name : requester[0].email }}
			} @else {
				{{ commentAuthorName }}
			}
			<mat-icon
				class="message-icon"
				[svgIcon]="isEmail() || autoGenerated() ? 'mail' : 'chat'"
			></mat-icon>
		</div>

		<div
			class="card-content nice-scroll colored-scroll-track"
			[ngClass]="
				autoGenerated() || isEmail() ? 'incoming-message' : 'outgoing-message comment'
			"
			[class.sent-by-me]="sentByMe()"
		>
			<div [class.comment-content]="!inEditMode()">
				@if (isEmail()) {
					@if (requester) {
						<div class="email-to">To: {{ requester[0].email }}</div>
					}
					<div class="date">{{ comment.created | dateAgo }}</div>
				}
				@if (!inEditMode()) {
					@if (isHtml(comment.text)) {
						<p class="comment" [innerHtml]="comment.text"></p>
					} @else {
						<p class="message" [innerText]="comment.text"></p>
					}
					@if (canEdit()) {
						<button
							class="actions"
							mat-icon-button
							[matMenuTriggerFor]="editMenu"
							[class.edit-mode]="inEditMode()"
						>
							<mat-icon svgIcon="more_vert"> </mat-icon>
						</button>
					}
				} @else {
					<div class="edit-comment-container" [formGroup]="commentEditInputForm">
						<quill-editor
							format="html"
							formControlName="textArea"
							class="edit-comment-area nice-scroll visible-scroll colored-scroll-track"
							[modules]="modules"
						>
						</quill-editor>
						<div class="submit-actions-group">
							<button
								mat-button
								class="action-group-item"
								(click)="inEditMode.set(false)"
							>
								{{ 'cancel' | translate }}
							</button>
							<button
								class="action-group-item"
								mat-flat-button
								(click)="submitEditedText()"
							>
								{{ 'save' | translate }}
							</button>
						</div>
					</div>
				}

				@if (comment.attachment) {
					<div class="attachment">
						<mat-icon svgIcon="file-image"></mat-icon>
						<a [href]="comment.attachment.link" target="_blank" class="attachment-name">{{
							comment.attachment.name
						}}</a>
					</div>
				}
			</div>
		</div>
	</div>
</div>

<mat-menu #editMenu="matMenu">
	<div>
		<button mat-menu-item (click)="inEditMode.set(true)">
			Edit
			<mat-icon svgIcon="pencil" class="accent-icon"></mat-icon>
		</button>
		<div class="divider"></div>
		<button mat-menu-item (click)="deleteComment()">
			Delete
			<mat-icon svgIcon="delete" class="critical-icon"></mat-icon>
		</button>
	</div>
</mat-menu>
